
import { defaultAgent, apiResponse } from '../helpers/web-agent';
import {
    GET_SCOUT_OBSERVATION_LIST_REQUEST, GET_SCOUT_OBSERVATION_LIST, GET_SCOUT_OBSERVATION_CONFIG_REQUEST, GET_SCOUT_OBSERVATION_CONFIG
} from '../constants/action-types';
import { toastError } from './toast';
import { tokenExpired } from './auth';



export const getScoutObservationListRequest = (optionType) => ({ type: GET_SCOUT_OBSERVATION_LIST_REQUEST });
export const scoutObservationList = (data = []) => ({ type: GET_SCOUT_OBSERVATION_LIST, payload: data });

export const getScoutObservationConfigRequest = (optionType) => ({ type: GET_SCOUT_OBSERVATION_CONFIG_REQUEST });
export const scoutObservationConfig = (data = []) => ({ type: GET_SCOUT_OBSERVATION_CONFIG, payload: data });

export const getScoutObservationList = (data, cb = null) => {
    return dispatch => {
        dispatch(getScoutObservationListRequest());
        defaultAgent.get('/api/scout/observation/list', { farm_uuid: data.farmId, is_current_user_observation: data.is_current_user_observation })
            .then(res => {
                const agentResult = apiResponse(res, []);
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                    dispatch(scoutObservationList());
                } else if (agentResult.data) {
                    if (!!cb) cb(agentResult.data)
                    dispatch(scoutObservationList(agentResult.data));
                }
            }).catch(ex => {
                if (defaultAgent.isCancel(ex)) return console.log('Scout Observation List: ', ex.message);
                dispatch(toastError(ex.message));
                dispatch(scoutObservationList());
            });
    }
}

export const getScoutObservationConfig = (data, cb = null) => {
    return dispatch => {
        dispatch(getScoutObservationConfigRequest());
        defaultAgent.get('/api/scout/observation/config', { farm_uuid: data.farmId })
            .then(res => {
                const agentResult = apiResponse(res, []);
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                    dispatch(scoutObservationConfig());
                } else if (agentResult.data) {
                    if (!!cb) cb(agentResult.data)
                    dispatch(scoutObservationConfig(agentResult.data));
                }
            }).catch(ex => {
                if (defaultAgent.isCancel(ex)) return console.log('Scout Observation Config: ', ex.message);
                dispatch(toastError(ex.message));
                dispatch(scoutObservationConfig());
            });
    }
}